module.exports = __webpack_public_path__ + "static/media/setpar-light.046c8c8b.svg";